module.exports = __webpack_public_path__ + "static/Image11@2x-e63dbbdba096ad382ef20b98720b6a7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image11@2x.jpg
// module id = 904
// module chunks = 227233210825294 244429959259914